import axios from 'index/axios'

// 波次列表
export function getWaveList(projectId) {
    return axios.post('/WaveManager/wave/list', { ProjectId: parseInt(projectId), Page: 1, PageSize: 100 })
}

// 波次详情
export function getWaveDetail(id) {
    return axios.get('/WaveManager/wave/detail', { id })
}

// 创建波次
export function createWave(data) {
    return axios.post('/WaveManager/wave/create', data)
}

// 更新波次
export function updateWave(data) {
    return axios.post('/WaveManager/wave/update', data)
}

// 删除波次
export function deleteWave(id) {
    return axios.post('/WaveManager/wave/delete', { Id: parseInt(id) })
}

// 获取波次经销商列表
export function getWaveDealers(waveId, params = {}) {
    return axios.post('/WaveManager/wave/dealer/list', { WaveId: parseInt(waveId), Page: 1, PageSize: 100, ...params })
}

// 获取波次经销商地区选项（省份/城市）
export function getDealerRegionOptions(waveId) {
    return axios.get('/WaveManager/wave/dealer/region-options', { waveId: parseInt(waveId) })
}

// 批量添加经销商
export function batchAddDealers(waveId, dealers) {
    return axios.post('/WaveManager/wave/dealer/batch-add', { waveId, dealers })
}

// 生成一店一码
export function generateDealerCodes(waveId) {
    const baseUrl = window.location.protocol + '//' + window.location.host
    return axios.post('/WaveManager/wave/dealer/generate-codes', { WaveId: parseInt(waveId), BaseUrl: baseUrl })
}

// 删除经销商
export function deleteDealer(id) {
    return axios.post('/WaveManager/wave/dealer/delete', { id })
}

// 上传经销商名单（Excel）
export function uploadDealerList(formData) {
    return axios.post('/WaveManager/wave/dealer/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// 导出经销商分配名单
export function exportDealerAssignList(waveId) {
    return axios.get('/WaveManager/wave/dealer/export-assign-list', { waveId }, { responseType: 'blob' })
}

// 导出经销商二维码
export function exportDealerQRCodes(waveId) {
    // 项目 axios 封装: get(url, params, options)
    // params 作为查询参数，options 包含 responseType
    return axios.get('/WaveManager/wave/dealer/export-qrcode', { waveId }, { responseType: 'blob' })
}

// 获取项目成员列表（代理选项）
export function getAgentOptions(projectId) {
    return axios.get('/WaveManager/wave/dealer/agent-options', { projectId: parseInt(projectId) })
}

// 更换门店代理（支持多代理）
export function changeDealerAgent(dealerId, agentUserIds) {
    return axios.post('/WaveManager/wave/dealer/change-agent', { DealerId: parseInt(dealerId), AgentUserIds: agentUserIds.map(id => parseInt(id)) })
}

// 获取门店当前已分配的代理
export function getDealerAgents(dealerId) {
    return axios.get('/WaveManager/wave/dealer/agents', { dealerId: parseInt(dealerId) })
}

// 概览按地区聚合（QC/Ops 专用）
export function getOverviewByRegion(waveId, viewType) {
    return axios.get('/WaveManager/overview/region', { waveId: parseInt(waveId), viewType })
}

// 导出经销商导入模板
export function exportDealerTemplate() {
    return axios.get('/WaveManager/wave/dealer/export-template', {}, { responseType: 'blob' })
}
